import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import { getShortContentUrl, useShortFromPropsOrParams } from '..';
import ContentStepIconIndicator from '../../../components/Navigator/LessonNavigator/ContentStepIconIndicator';
import ExpandedTrackNavigatorTopLevel from '../../../components/Navigator/TrackNavigator/ExpandedTrackNavigatorTopLevel';
import { NextPlaylistContent } from '../../playlistContent';
import ContentItem from '../../../components/Navigator/LessonNavigator/ContentItem';
import { ShortCardTimeReadout } from '../../cards';
import { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortContentPlaylistNavigation = props => {
  const {
    shortId,
    short,
    language,
    playlistNavigation
  } = useShortFromPropsOrParams(props);
  if (!shortId || !language || !short) return null;
  const renderStepIconComponent = ({
    circleSize
  }) => {
    return /*#__PURE__*/_jsx(ContentStepIconIndicator, {
      circleSize: circleSize,
      isActive: !playlistNavigation,
      language: language,
      shortId: shortId
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        padding: '24px 36px 0',
        borderBottom: `solid 1px ${theme.colors.BATTLESHIP}`,
        backgroundColor: playlistNavigation ? theme.colors.OLAF : 'transparent'
      },
      children: /*#__PURE__*/_jsx(UIStepIndicator, {
        StepIconComponent: renderStepIconComponent,
        circleSize: 10,
        direction: "vertical",
        stepIndex: 0,
        stepNames: [/*#__PURE__*/_jsx(ContentItem, {
          heading: short.name,
          subheading: /*#__PURE__*/_jsx(ShortCardTimeReadout, {
            language: language,
            shortId: shortId
          }),
          url: getShortContentUrl({
            shortId,
            language
          }).fullUrl
        }, "short-playlist-nav")]
      })
    }), /*#__PURE__*/_jsx(NextPlaylistContent, {
      language: language,
      render: ({
        title,
        subtitle,
        url
      }) => /*#__PURE__*/_jsx(ExpandedTrackNavigatorTopLevel, {
        "data-test-id": "expanded-track-navigator-next-playlist-content",
        heading: title,
        isSelected: !!playlistNavigation,
        subheading: subtitle,
        url: url
      }),
      shortId: shortId
    })]
  });
};